import { registerPopupComponent } from '@pressreader/ui-popups';

import { CopyArticleDialogWrapperLazy } from './lazy';

const POPUPS_TEXTVIEW_NAME = 'v7.Client.Dialogs.TextView';

let initialized = false;
const initResult = Object.freeze({
    name: POPUPS_TEXTVIEW_NAME,
});
export function init() {
    if (initialized) {
        return initResult;
    }

    registerPopupComponent(POPUPS_TEXTVIEW_NAME, CopyArticleDialogWrapperLazy);
    initialized = true;

    return initResult;
}
